"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var validation_1 = require("../model/validation");
var validation_severity_1 = require("../model/validation-severity");
var validation_priority_1 = require("../model/validation-priority");
var idm_kb_service_client_js_1 = require("@synisys/idm-kb-service-client-js");
var validations_calculations_data_model_1 = require("../model/validations-calculations-data.model");
var idm_de_core_frontend_1 = require("@synisys/idm-de-core-frontend");
var meta_field_id_1 = require("@synisys/idm-kb-service-client-js/src/model/meta-field-id");
var meta_category_id_1 = require("@synisys/idm-kb-service-client-js/src/model/meta-category-id");
var validation_display_1 = require("../model/validation-display");
var validation_display_type_1 = require("../model/validation-display-type");
var validation_message_data_1 = require("../model/validation-message-data");
function deserializeValidationsCalculationsData(data, metaFields, languages) {
    var validations = deserializeValidations(data.calculationErrorDtoData.validationErrorDtos, metaFields, languages);
    var calculations = deserializeCalculations(data.calculationErrorDtoData.calculationWarningDtos, metaFields, languages);
    return new validations_calculations_data_model_1.ValidationsCalculationsData(validations, calculations, data.data);
}
exports.deserializeValidationsCalculationsData = deserializeValidationsCalculationsData;
function deserializeValidations(data, metaFields, languages) {
    var validations = [];
    var validationPriorityHelper = new validation_priority_1.ValidationPriorityHelper();
    var validationSeverityHelper = new validation_severity_1.ValidationSeverityHelper();
    data.forEach(function (dataItem) {
        var message = idm_de_core_frontend_1.deserializeMultilingualString(dataItem.message.values, languages);
        var messageOfMessageData = dataItem.messageData ? idm_de_core_frontend_1.deserializeMultilingualString(dataItem.messageData.message.values, languages) : null;
        var dataOfMessageData = dataItem.messageData ? dataItem.messageData.data : null;
        var messageData = new validation_message_data_1.ValidationMessageData(messageOfMessageData, dataOfMessageData);
        var identityId = dataItem.identityId ? (+dataItem.identityId) : null;
        var descriptionMessage = idm_de_core_frontend_1.deserializeMultilingualString(dataItem.messageDescription.values, languages);
        var messageOfMessageDataDescription = dataItem.messageDescriptionData ? idm_de_core_frontend_1.deserializeMultilingualString(dataItem.messageDescriptionData.message.values, languages) : null;
        var dataOfMessageDataDescription = dataItem.messageDescriptionData ? dataItem.messageDescriptionData.data : null;
        var descriptionMessageData = new validation_message_data_1.ValidationMessageData(messageOfMessageDataDescription, dataOfMessageDataDescription);
        var relatedMetaFieldIds = deserializeRelatedFields(dataItem.relatedFields);
        var validatorLabel = dataItem.validatorLabel;
        validations.push(new validation_1.Validation(message, descriptionMessage, validationSeverityHelper.getSeverity(dataItem.validationSeverity), validationPriorityHelper.getPriority(dataItem.validationPriority), validatorLabel, relatedMetaFieldIds, deserializeDisplayType(dataItem), messageData, descriptionMessageData, identityId));
    });
    return validations;
}
exports.deserializeValidations = deserializeValidations;
function deserializeCalculations(response, metaFields, languages) {
    return [];
}
exports.deserializeCalculations = deserializeCalculations;
function deserializeRelatedFields(relatedMetaFieldsDtos) {
    var relatedFields = [];
    relatedMetaFieldsDtos.forEach(function (relatedMetaField) {
        relatedFields.push(new meta_field_id_1.MetaFieldId(new meta_category_id_1.MetaCategoryId(relatedMetaField.metaCategoryId.systemName), relatedMetaField.systemName, relatedMetaField.groupId ? new idm_kb_service_client_js_1.MetaGroupId(relatedMetaField.groupId.systemName) : null));
    });
    return relatedFields;
}
function deserializeDisplayType(dataItem) {
    if (dataItem && dataItem.validationDisplay) {
        var validationDisplayTypeHelper = new validation_display_type_1.ValidationDisplayTypeHelper();
        return new validation_display_1.ValidationDisplay(validationDisplayTypeHelper.getDisplayType(dataItem.validationDisplay.displayType), convertObjectToMap(dataItem.validationDisplay.displayData));
    }
    return null;
}
function convertObjectToMap(obj) {
    var strMap = new Map();
    for (var _i = 0, _a = Object.keys(obj); _i < _a.length; _i++) {
        var k = _a[_i];
        strMap.set(k, obj[k]);
    }
    return strMap;
}
//# sourceMappingURL=validation-service-deserialization-helper.js.map